import InputMask from "inputmask";
import { VueConstructor } from "vue";
import "inputmask/lib/extensions/inputmask.date.extensions";

export type InputMaskOptions = InputMask.Options;
const MaskMap = new Map<number, InstanceType<typeof InputMask>>();
let maskId = 0;
export default {
  install(Vue: VueConstructor) {
    Vue.directive("input-mask", {
      bind: function(el, binding) {
        maskId++;
        let mask = binding.value;
        const im = new InputMask(mask).mask(el);
        el.dataset.inputMaskId = maskId.toString();
        MaskMap.set(maskId, im);
      },
      unbind(el) {
        const maskId = Number(el.dataset.inputMaskId);
        const im = MaskMap.get(maskId);
        im && im.remove();
        MaskMap.delete(maskId);
      },
    });
  },
};
